import apiClient from "../apiClient";

const resource = "doctorsStock";

export default {
    getAll: params => apiClient.get(`${resource}?${params}`),
    getDetails: id => apiClient.get(`${resource}/${id}/details`),
    getDispensesDetails: id => apiClient.get(`${resource}/${id}/dispenses`),
    getForEdit: id => apiClient.get(`${resource}/${id}`),
    add: payload => apiClient.post(`${resource}`, payload),
    addStock: payload => apiClient.post(`${resource}/stock`, payload),
    addDispense: payload => apiClient.post(`${resource}/dispense`, payload),
    
    getMedicines: doctorId => apiClient.get(`${resource}/medicines?doctorId=${doctorId}`),
};
